module.exports = __webpack_public_path__ + "img/1.21_Russian_road_sign.3777ae67.svg";